import { VerificationCycle, VerificationStatus } from '../types';

/**
 * Interface representing an entity with verification properties
 */
export interface VerifiableEntity {
  isVerifiable?: boolean;
  isArchived?: boolean;
  isVerificationWindowOpen?: boolean;
  verificationCycle?: VerificationCycle;
  verificationStatus?: VerificationStatus;
}

/**
 * Determines if a user can be verified based on verification window and current status
 * 
 * @param entity - The entity to check (must have verification properties)
 * @returns true if the entity can be verified, false otherwise
 */
export const canVerifyUser = (entity: VerifiableEntity): boolean => {
  // Cannot verify if entity is archived or not verifiable
  if (entity.isArchived || !entity.isVerifiable) {
    return false;
  }

  // Can verify if:
  // 1. Verification window is open AND it's the current cycle, OR
  // 2. Verification status is not verified
  return (
    (entity.isVerificationWindowOpen && entity.verificationCycle === VerificationCycle.Current) ||
    (entity.verificationStatus !== VerificationStatus.Verified)
  );
};
